import Confirmation from 'modules/auth/confirmation'

export default function ConfirmationPage() {
    return <Confirmation />
}
